import dayjs from "dayjs";
import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { uplusState } from "../../../../Enum/state.Enum";
import { useApi } from "../../../../hooks/useApi";
import { authType } from "../../../../pages/Login";
import LineBtn from "../../../Button/LineBtn";
import Blank from "../../../DefaultStyles/Blank";
import DotStatus from "../../../DefaultStyles/DotStatus";
import LineBox from "../../../DefaultStyles/LineBox";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import AlertModal from "../../../Modal/AlertModal";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";

interface UserDetailUplusInfoProps {
  userId?: string;
}

interface IUplus {
  enddate?: string;
  id: string;
  name: string;
  nickname: string;
  phoneNum: string;
  ratePlan: string;
  reason: string;
  regName: string;
  reqDate: string;
  startdate?: string;
  state: number;
  uid: string;
  updatedate: string;
  writer: string;
  key: string;
  birthday: string;
}

export default function UserDetailUplusInfo({
  userId,
}: UserDetailUplusInfoProps) {
  const auth = useRecoilValue(authType);

  const [page, setPage] = useState(0);
  const [viewKey, setViewKey] = useState({
    modal: false,
    key: "",
  });

  const { response } = useApi({
    method: "get",
    url: auth?.uplus
      ? `uplus?page=${page}&size=5` + (userId ? `&uid=${userId}` : ``)
      : undefined,
  });

  const uplusInfoHeader = [
    "ID",
    "Key",
    "등록 이름",
    "등록 전화번호",
    "등록 생년월일",
    "결합 상태",
    "사유",
    "매칭 신청일",
    "결합 시작일",
    "결합 종료일",
    "최종 업데이트",
    "담당자",
  ];

  return (
    <>
      {response?.data?.items?.length > 0 && (
        <>
          <LineBox>
            <TitleWithLine title="유플러스 결합 정보" />

            <Blank blankHeight={24} />

            <Table tableHeadData={uplusInfoHeader}>
              <>
                {response?.data?.items?.map((d: IUplus) => {
                  return (
                    <TableBody>
                      <TableBodyItem>{d?.id}</TableBodyItem>
                      <TableBodyItem>
                        <LineBtn
                          btnText="보기"
                          btnClickEvent={() =>
                            setViewKey({
                              modal: true,
                              key: d?.key ?? "",
                            })
                          }
                        />
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.regName}
                      </TableBodyItem>
                      <TableBodyItem>
                        {d?.phoneNum?.length > 0 ? d?.phoneNum : `-`}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.birthday?.length > 0
                          ? dayjs(d?.birthday).format("YYYY-MM-DD")
                          : "-"}
                      </TableBodyItem>
                      <TableBodyItem style={{ minWidth: 89 }}>
                        <DotStatus
                          size="sm"
                          color={
                            d?.state === 1
                              ? "#ffb100"
                              : d?.state === 2
                              ? "#00c7c7"
                              : d?.state === 3
                              ? "#858c97"
                              : "#f42d16"
                          }
                          text={uplusState[d?.state]}
                        />
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.reason?.length > 0 ? d?.reason : "-"}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {dayjs(d?.reqDate ?? undefined)?.format(
                          "YYYY-MM-DD HH:mm"
                        )}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.startdate!?.length > 0
                          ? dayjs(d?.startdate).format("YYYY-MM-DD")
                          : "-"}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.enddate
                          ? dayjs(d?.enddate ?? undefined)?.format(
                              "YYYY-MM-DD HH:mm"
                            )
                          : "-"}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {dayjs(d?.updatedate ?? undefined)?.format(
                          "YYYY-MM-DD HH:mm"
                        )}
                      </TableBodyItem>
                      <TableBodyItem>
                        {d?.writer?.length > 0 ? d?.writer : "-"}
                      </TableBodyItem>
                    </TableBody>
                  );
                })}
              </>
            </Table>

            <Pagination
              totalPage={
                response?.status === 200 ? response?.data?.totalPage : 3
              }
              currentPage={page}
              pageClickEvent={(index) => setPage(index)}
            />
          </LineBox>

          <Blank blankHeight={20} />

          {viewKey?.modal && (
            <AlertModal
              title={"Key"}
              desc={viewKey?.key ?? ""}
              customCancelBtn={<></>}
              btnColor="mint"
              isSmallDesc={13}
              confirmEvent={() =>
                setViewKey({
                  modal: false,
                  key: "",
                })
              }
            />
          )}
        </>
      )}
    </>
  );
}
